var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main-wrapper signin-form center signin-wrapper-padding" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("h3", { staticClass: "text-align-center margin-bottom-35" }, [
          _vm._v("Create Password")
        ]),
        _vm._v(" "),
        _c("flash-message", { attrs: { autoHide: "", variant: "success" } }),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.onSubmit($event)
              }
            }
          },
          [
            _c("div", { staticClass: "row margin-bottom-15" }, [
              _c("div", { staticClass: "col-12 col-sm-12" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:10|special_char|number",
                      expression: "'required|min:10|special_char|number'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  ref: "password",
                  staticClass: "col-12 col-sm-12 input-height-35",
                  attrs: {
                    type: "password",
                    name: "password",
                    id: "password",
                    "data-vv-as": "Password",
                    maxlength: "20"
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.verrors.has("password"),
                        expression: "verrors.has('password')"
                      }
                    ],
                    staticClass: "validate-warning-msg"
                  },
                  [_vm._v(_vm._s(_vm.verrors.first("password")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ml-2 mt-2",
                    class:
                      _vm.password && _vm.passwordLengthValid
                        ? "text-success"
                        : _vm.password && !_vm.passwordLengthValid
                        ? "text-danger"
                        : "text-muted",
                    staticStyle: { "margin-left": "0 !important" }
                  },
                  [
                    _c("i", {
                      staticClass: "fa mr-1",
                      class:
                        _vm.password && _vm.passwordLengthValid
                          ? "fa-check-circle"
                          : _vm.password && !_vm.passwordLengthValid
                          ? "fa-times"
                          : ""
                    }),
                    _vm._v("\n          10 or more characters\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ml-2",
                    class:
                      _vm.password && _vm.containsSpecialChar
                        ? "text-success"
                        : _vm.password && !_vm.containsSpecialChar
                        ? "text-danger"
                        : "text-muted",
                    staticStyle: { "margin-left": "0 !important" }
                  },
                  [
                    _c("i", {
                      staticClass: "fa mr-1",
                      class:
                        _vm.password && _vm.containsSpecialChar
                          ? "fa-check-circle"
                          : _vm.password && !_vm.containsSpecialChar
                          ? "fa-times"
                          : ""
                    }),
                    _vm._v(
                      "\n          1 or more special characters (*,!,#, etc)\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ml-2 mb-0",
                    class:
                      _vm.password && _vm.containsNumber
                        ? "text-success"
                        : _vm.password && !_vm.containsNumber
                        ? "text-danger"
                        : "text-muted",
                    staticStyle: { "margin-left": "0 !important" }
                  },
                  [
                    _c("i", {
                      staticClass: "fa mr-1",
                      class:
                        _vm.password && _vm.containsNumber
                          ? "fa-check-circle"
                          : _vm.password && !_vm.containsNumber
                          ? "fa-times"
                          : ""
                    }),
                    _vm._v("\n          1 or more numbers\n        ")
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row margin-bottom-15" }, [
              _c("div", { staticClass: "col-12 col-sm-12" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password|min:6",
                      expression: "'required|confirmed:password|min:6'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirm_password,
                      expression: "confirm_password"
                    }
                  ],
                  ref: "confirm_password",
                  staticClass: "col-12 col-sm-12 input-height-35",
                  attrs: {
                    type: "password",
                    name: "confirm_password",
                    id: "confirm_password",
                    "data-vv-as": "Confirm password",
                    maxlength: "20"
                  },
                  domProps: { value: _vm.confirm_password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.confirm_password = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.verrors.firstByRule("confirm_password", "required")
                  ? _c(
                      "div",
                      { staticClass: "margin-bottom-5 validate-warning-msg" },
                      [
                        _vm._v(
                          "\n          The Confirm Password field is required"
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.verrors.firstByRule("confirm_password", "confirmed")
                  ? _c(
                      "div",
                      { staticClass: "margin-bottom-5 validate-warning-msg" },
                      [
                        _vm._v(
                          "The Password and Confirm Password does not match"
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm._m(3)
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "text-align-center margin-bottom-20 mm-logo" },
      [_c("img", { attrs: { src: require("@/assets/MM-logo.png") } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-12", attrs: { for: "password" } }, [
      _vm._v("New Password : "),
      _c("span", { staticClass: "required" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "col-12", attrs: { for: "confirm_password" } },
      [
        _vm._v("Confirm Password : "),
        _c("span", { staticClass: "required" }, [_vm._v("*")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "submit margin-bottom-15 float-right" }, [
      _c(
        "button",
        { staticClass: "btn btn-info btn-md", attrs: { type: "submit" } },
        [_vm._v("Confirm")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-756e4b6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756e4b6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/change_password.vue
// module id = null
// module chunks = 